import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const FeedbackError = ({ message, className, text }) => {
  const componentClass = classNames({ [className]: className })

  return (
    <div className={componentClass}>
      <div className='feedback feedback-error margin-bottom-double'>
        <div className='feedback-title'>{message}</div>

        {text && <div>{text}</div>}
      </div>
    </div>
  )
}

FeedbackError.propTypes = {
  message: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
}

export default FeedbackError
